    // Section with Editor
$(document).on('shopify:section:load', function(e){ 
  $('#' + e.target.id).find('[data-section]').sectionJs();
}).ready(function() {
  $('[data-section]').each(function(){ $(this).sectionJs() });
});

$.fn.sectionJs = function(){
  var $this = this;
  if($this.data('section') == "SlideShow") {
     $this.find('.slider-active-5').SlideShow();
  }else if($this.data('section') == "SlideShow_2") {
    $this.find('.slider-active-5').SlideShow_2();
  }else if($this.data('section') == "SlideShow_3") {
    $this.find('.slider-active-1').SlideShow_3();
  }else if($this.data('section') == "SlideShow_4") {
    $this.find('.slider-active-1').SlideShow_4();
  }else if($this.data('section') == "SlideShow_5") {
    $this.find('.slider-active-1').SlideShow_5();
  }else if($this.data('section') == "SlideShow_6") {
    $this.find('.slider-active-4').SlideShow_6();
  }else if($this.data('section') == "SlideShow_7") {
    $this.find('.slider-active-1').SlideShow_7();
  }else if($this.data('section') == "SlideShow_8") {
    $this.find('.slider-active-1').SlideShow_8();
  }else if($this.data('section') == "SlideShow_9") {
    $this.find('.slider-active-2').SlideShow_9();
  }else if($this.data('section') == "SlideShow_10") {
    $this.find('.slider-active-3').SlideShow_10();
  }else if($this.data('section') == "SlideShow_11") {
    $this.find('.slider-active-1').SlideShow_11();
  }else if($this.data('section') == "SlideShow_12") {
    $this.find('.slider-active-1').SlideShow_12();
  }else if($this.data('section') == "SlideShow_13") {
    $this.find('.slider-active-1').SlideShow_13();
  }else if($this.data('section') == "SlideShow_14") {
    $this.find('.slider-active-1').SlideShow_14();
  }else if($this.data('section') == "SlideShow_15") {
    $this.find('.slider-active-1').SlideShow_15();
  }else if($this.data('section') == "SlideShow_16") {
    $this.find('.slider-active-1').SlideShow_16();
  }else if($this.data('section') == "SlideShow_17") {
    $this.find('.slider-active-1').SlideShow_17();
  }else if($this.data('section') == "SlideShow_18") {
    $this.find('.slider-active-1').SlideShow_18();
  }else if($this.data('section') == "CategorieArea") {
    $this.find('.categori-slider-active').CategorieArea();
  }else if($this.data('section') == "FeaturedCollection") {
    $this.find('.product-slider-active-4').FeaturedCollection();
  }else if($this.data('section') == "FeaturedCollection_2") {
    $this.find('.product-slider-active-3').FeaturedCollection_2();
  }else if($this.data('section') == "FeaturedCollection_3") {
    $this.find('.product-slider-active-2').FeaturedCollection_3();
  }else if($this.data('section') == "TabWithProduct") {
    $this.find('.product-slider-active-1').TabWithProduct();
  }else if($this.data('section') == "NewArrivals") {
    $this.find('.small_product_active').NewArrivals();
  }else if($this.data('section') == "Testimonial") {
    $this.find('.testimonial-active-7').Testimonial();
  }else if($this.data('section') == "BrandLogo") {
    $this.find('.brand-logo-active-3').BrandLogo();
  }else if($this.data('section') == "BrandLogo_2") {
    $this.find('.brand-logo-active').BrandLogo_2();
  }else if($this.data('section') == "BrandLogo_3") {
    $this.find('.brand-logo-active-2').BrandLogo_3();
  }else if($this.data('section') == "BrandLogo_4") {
    $this.find('.brand-logo-active-2').BrandLogo_4();
  }else if($this.data('section') == "BrandLogo_5") {
    $this.find('.brand-logo-active').BrandLogo_5();
  }else if($this.data('section') == "Instagram") {
        $this.InstagramSection();
  }else if($this.data('section') == "TestimonialArea") {
        $this.TestimonialAreaSection();
  }else if($this.data('section') == "TestimonialArea_2") {
        $this.TestimonialArea_2Section();
  }else if($this.data('section') == "TestimonialArea_3") {
    $this.find('.testimonial-active').TestimonialArea_3();
  }else if($this.data('section') == "TestimonialArea_4") {
        $this.TestimonialArea_4Section();
  }else if($this.data('section') == "TestimonialArea_5") {
    $this.find('.testimonial-active-5').TestimonialArea_5();
  }else if($this.data('section') == "TestimonialArea_6") {
    $this.find('.testimonial-active-5').TestimonialArea_6();
  }else if($this.data('section') == "TestimonialArea_7") {
    $this.find('.testimonial-active-5').TestimonialArea_7();
  }else if($this.data('section') == "TestimonialArea_8") {
    $this.find('.testimonial-active-6').TestimonialArea_8();
  }else if($this.data('section') == "TestimonialArea_9") {
    $this.find('.testimonial-active-5').TestimonialArea_9();
  }else if($this.data('section') == "RelatedProduct") {
    $this.find('.product-slider-active-4').RelatedProduct();
  }else if($this.data('section') == "CustomCollection") {
    $this.find('.product-slider-active-4').CustomCollection();
  }else if($this.data('section') == "HeaderSections") {
    $this.HeaderSectionsActivation();
  }else if($this.data('section') == "BannerWithCollection") {
    $this.find('.product_column2').BannerWithCollection();
  }else if($this.data('section') == "CollectionThumbnail") {
    $this.find('.product_column1').CollectionThumbnail();
  }else if($this.data('section') == "SectionWithSidebar") {
    $this.SectionWithSidebar();
  }else if($this.data('section') == "SectionWithSidebar2") {
    $this.SectionWithSidebar2();
  }else{}   
}
   




     // SlideShow 2 active js
$.fn.SlideShow_2 = function() {
  var $SlideShow_2VAR = this;
  $SlideShow_2VAR.slick({
    adaptiveHeight: true,
    speed: 1000,
    fade: true,
    loop: true,
    dots: true,
    arrows: false,
    prevArrow: '<span class="slider-icon slider-icon-prev"><i class="icofont-simple-left"></i></span>',
    nextArrow: '<span class="slider-icon slider-icon-next"><i class="icofont-simple-right"></i></span>',
    
  });
};




    // Categorie Area active js
$.fn.CategorieArea = function() {
  var $CategorieAreaVAR = this;
  $CategorieAreaVAR.slick({
    adaptiveHeight: true,
    speed: 1000,
    loop: true,
    dots: false,
    fade: false,
    arrows: false
    
  });
};



    // Featured Collection active js
$.fn.FeaturedCollection = function() {
  var $FeaturedCollectionVAR = this;
  $FeaturedCollectionVAR.slick({
    adaptiveHeight: true,
    speed: 1000,
    loop: true,
    dots: false,
    fade: false,
    arrows: false
    
  });
};


    // Featured Collection 2 active js
$.fn.FeaturedCollection_2 = function() {
  var $FeaturedCollection_2VAR = this;
  $FeaturedCollection_2VAR.slick({
    adaptiveHeight: true,
    speed: 1000,
    loop: true,
    dots: false,
    fade: false,
    arrows: false
    
  });
};

    // Featured Collection 3 active js
$.fn.FeaturedCollection_3 = function() {
  var $FeaturedCollection_3VAR = this;
  $FeaturedCollection_3VAR.slick({
    adaptiveHeight: true,
    speed: 1000,
    loop: true,
    dots: false,
    fade: false,
    arrows: false
    
  });
};

    // Tab With Product active js
$.fn.TabWithProduct = function() {
  var $TabWithProductVAR = this;
  $TabWithProductVAR.slick({
    adaptiveHeight: true,
    speed: 1000,
    loop: true,
    dots: false,
    fade: false,
    arrows: false
    
  });
};

    // Testimonial active js
$.fn.Testimonial = function() {
  var $TestimonialVAR = this;
  $TestimonialVAR.slick({
    adaptiveHeight: true,
    speed: 1000,
    loop: true,
    dots: false,
    fade: false,
    arrows: false
    
  });
};


    // Brand Logo active js
$.fn.BrandLogo = function() {
  var $BrandLogoVAR = this;
  $BrandLogoVAR.slick({
    adaptiveHeight: true,
    speed: 1000,
    loop: true,
    dots: false,
    fade: false,
    arrows: false
    
  });
};



    // Brand Logo 2 active js
$.fn.BrandLogo_2 = function() {
  var $BrandLogo_2VAR = this;
  $BrandLogo_2VAR.slick({
    adaptiveHeight: true,
    speed: 1000,
    loop: true,
    dots: false,
    fade: false,
    arrows: false
    
  });
};


    // Brand Logo 3 active js
$.fn.BrandLogo_3 = function() {
  var $BrandLogo_3VAR = this;
  $BrandLogo_3VAR.slick({
    adaptiveHeight: true,
    speed: 1000,
    loop: true,
    dots: false,
    fade: false,
    arrows: false
    
  });
};


    // Brand Logo 4 active js
$.fn.BrandLogo_4 = function() {
  var $BrandLogo_4VAR = this;
  $BrandLogo_4VAR.slick({
    adaptiveHeight: true,
    speed: 1000,
    loop: true,
    dots: false,
    fade: false,
    arrows: false
    
  });
};



    // Brand Logo 5 active js
$.fn.BrandLogo_5 = function() {
  var $BrandLogo_5VAR = this;
  $BrandLogo_5VAR.slick({
    adaptiveHeight: true,
    speed: 1000,
    loop: true,
    dots: false,
    fade: false,
    arrows: false
    
  });
};

  
    
    // Instgram active js
    $.fn.InstagramSection = function(){
      var activation = this.find('[data-username]'),
          activeId = activation.attr('id'),
          clientUsername = activation.attr('data-username'),
          instagramHastag = activation.attr('data-hashtag'),
          ItemsLimit = activation.attr('data-limit'),
          imageSize = activation.attr('data-size'),
          instaslider = ".instagram-carousel";

      $.instagramFeed({
        'tag': instagramHastag,
        'username': clientUsername,
        'container': "#"+activeId,
        'display_profile': false,
        'display_biography': false,
        'display_gallery': true,
        'styling': false,
        'items': ItemsLimit,
        'margin': 1,
        'image_size': imageSize
      });

 
    };


  // Testimonial Area active js
    $.fn.TestimonialAreaSection = function(){

    /*------------------------------------
        Testimonial img slider active
    -----------------------------------*/
    $('.testimonial-img-slider-active').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
   
        arrows: false,
        draggable: false,
        fade: false,
        asNavFor: '.testimonial-active-3',
    });

    /*--------------------------------
       Testimonial active 3
    -----------------------------------*/
    $('.testimonial-active-3').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
   
        asNavFor: '.testimonial-img-slider-active , .testimonial-img-slider-active-3',
        dots: true,
        focusOnSelect: true,
        fade: true,
        arrows: false
    });
    
    /*----------------------------------------------------------
        Testimonial img slider active 3 ( home mega fashion )
    --------------------------------------------------------------*/
    $('.testimonial-img-slider-active-3').on('init afterChange',function(){
        const titleImg = document.querySelector('.testimonial-next-img img');
        const activeSlide = document.querySelector('.testimonial-img-slider.slick-current');
        titleImg.src = activeSlide.nextSibling.querySelector('img').src;
    });
    $('.testimonial-img-slider-active-3').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
   
        arrows: false,
        draggable: false,
        fade: false,
        asNavFor: '.testimonial-active-3'
    });
    

      
      
    };



  // Testimonial Area 2 active js
    $.fn.TestimonialArea_2Section = function(){

      /*------------------------------------
        testimonial img slider active 2
    --------------------------------------*/
    $('.testimonial-img-slider-active-2').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
   
        arrows: false,
        dots: false,
        focusOnSelect: true,
        draggable: false,
        fade: false,
        asNavFor: '.testimonial-active-4',
        responsive: [
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 4,
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 5,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 2,
                }
            }
        ]
    });

    /*--------------------------------
        Testimonial active 4
    -----------------------------------*/
    $('.testimonial-active-4').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
   
        asNavFor: '.testimonial-img-slider-active-2',
        dots: false,
        focusOnSelect: true,
        fade: true,
        arrows: false
    });
      
      
      
      
     };
     



     // Testimonial Area 3 active js
$.fn.TestimonialArea_3 = function() {
  var $TestimonialArea_3VAR = this;
  $TestimonialArea_3VAR.slick({
    adaptiveHeight: true,
    speed: 1000,
    loop: true,
    dots: false,
    fade: false,
    arrows: false
    
  });
};




  // Testimonial Area 4 active js
    $.fn.TestimonialArea_4Section = function(){

    /*------------------------------------
        Testimonial img slider active
    -----------------------------------*/
    $('.testimonial-img-slider-active').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
   
        arrows: false,
        draggable: false,
        fade: false,
        asNavFor: '.testimonial-active-3',
    });

    /*--------------------------------
       Testimonial active 3
    -----------------------------------*/
    $('.testimonial-active-3').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
   
        asNavFor: '.testimonial-img-slider-active , .testimonial-img-slider-active-3',
        dots: true,
        focusOnSelect: true,
        fade: true,
        arrows: false
    });
    
    /*----------------------------------------------------------
        Testimonial img slider active 3 ( home mega fashion )
    --------------------------------------------------------------*/
    $('.testimonial-img-slider-active-3').on('init afterChange',function(){
        const titleImg = document.querySelector('.testimonial-next-img img');
        const activeSlide = document.querySelector('.testimonial-img-slider.slick-current');
        titleImg.src = activeSlide.nextSibling.querySelector('img').src;
    });
    $('.testimonial-img-slider-active-3').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
   
        arrows: false,
        draggable: false,
        fade: false,
        asNavFor: '.testimonial-active-3'
    });
      
      
      
     };


     // Testimonial Area 5 active js
$.fn.TestimonialArea_5 = function() {
  var $TestimonialArea_5VAR = this;
  $TestimonialArea_5VAR.slick({
    adaptiveHeight: true,
    speed: 1000,
    loop: true,
    dots: false,
    fade: false,
    arrows: false
    
  });
};




     // Testimonial Area 6 active js
$.fn.TestimonialArea_6 = function() {
  var $TestimonialArea_6VAR = this;
  $TestimonialArea_6VAR.slick({
    adaptiveHeight: true,
    speed: 1000,
    loop: true,
    dots: false,
    fade: false,
    arrows: false
    
  });
};



     // Testimonial Area 7 active js
$.fn.TestimonialArea_7 = function() {
  var $TestimonialArea_7VAR = this;
  $TestimonialArea_7VAR.slick({
    adaptiveHeight: true,
    speed: 1000,
    loop: true,
    dots: false,
    fade: false,
    arrows: false
    
  });
};



     // Testimonial Area 8 active js
$.fn.TestimonialArea_8 = function() {
  var $TestimonialArea_8VAR = this;
  $TestimonialArea_8VAR.slick({
    adaptiveHeight: true,
    speed: 1000,
    loop: true,
    dots: false,
    fade: false,
    arrows: false
    
  });
};

     // Testimonial Area 9 active js
$.fn.TestimonialArea_9 = function() {
  var $TestimonialArea_9VAR = this;
  $TestimonialArea_9VAR.slick({
    adaptiveHeight: true,
    speed: 1000,
    loop: true,
    dots: false,
    fade: false,
    arrows: false
    
  });
};



     // Related Product active js
$.fn.RelatedProduct = function() {
  var $RelatedProductVAR = this;
  $RelatedProductVAR.slick({
    adaptiveHeight: true,
    speed: 1000,
    loop: true,
    dots: false,
    fade: false,
    arrows: false
    
  });
};



     // Custom Collection active js
$.fn.CustomCollection = function() {
  var $CustomCollectionVAR = this;
  $CustomCollectionVAR.slick({
    adaptiveHeight: true,
    speed: 1000,
    loop: true,
    dots: false,
    fade: false,
    arrows: false
    
  });
};




     // SlideShow active js
$.fn.SlideShow = function() {
  var $SlideShowVAR = this;
  $SlideShowVAR.slick({
    adaptiveHeight: true,
    speed: 1000,
    fade: true,
    loop: true,
    dots: true,
    arrows: false,
    prevArrow: '<span class="slider-icon slider-icon-prev"><i class="icofont-simple-left"></i></span>',
    nextArrow: '<span class="slider-icon slider-icon-next"><i class="icofont-simple-right"></i></span>',
    
  });
};




     // SlideShow 3 active js
$.fn.SlideShow_3 = function() {
  var $SlideShow_3VAR = this;
  $SlideShow_3VAR.slick({
    adaptiveHeight: true,
    speed: 1000,
    fade: true,
    loop: true,
    dots: false,
    arrows: true,
    prevArrow: '<span class="slider-icon slider-icon-prev"><i class="icofont-simple-left"></i></span>',
    nextArrow: '<span class="slider-icon slider-icon-next"><i class="icofont-simple-right"></i></span>',
    
  });
};



     // SlideShow 4 active js
$.fn.SlideShow_4 = function() {
  var $SlideShow_4VAR = this;
  $SlideShow_4VAR.slick({
    adaptiveHeight: true,
    speed: 1000,
    fade: true,
    loop: true,
    dots: false,
    arrows: true,
    prevArrow: '<span class="slider-icon slider-icon-prev"><i class="icofont-simple-left"></i></span>',
    nextArrow: '<span class="slider-icon slider-icon-next"><i class="icofont-simple-right"></i></span>',
    
  });
};

     // SlideShow 5 active js
$.fn.SlideShow_5 = function() {
  var $SlideShow_5VAR = this;
  console.log($SlideShow_5VAR);
  $SlideShow_5VAR.slick({
    adaptiveHeight: true,
    speed: 1000,
    fade: true,
    loop: true,
    dots: false,
    arrows: true,
    prevArrow: '<span class="slider-icon slider-icon-prev"><i class="icofont-simple-left"></i></span>',
    nextArrow: '<span class="slider-icon slider-icon-next"><i class="icofont-simple-right"></i></span>',
    
  });
};



     // SlideShow 6 active js
$.fn.SlideShow_6 = function() {
  var $SlideShow_6VAR = this;
  $SlideShow_6VAR.slick({
    adaptiveHeight: true,
    speed: 1000,
    fade: true,
    loop: true,
    dots: true,
    arrows: false,
    prevArrow: '<span class="slider-icon slider-icon-prev"><i class="icofont-simple-left"></i></span>',
    nextArrow: '<span class="slider-icon slider-icon-next"><i class="icofont-simple-right"></i></span>',
    
  });
};



     // SlideShow 7 active js
$.fn.SlideShow_7 = function() {
  var $SlideShow_7VAR = this;
  $SlideShow_7VAR.slick({
    adaptiveHeight: true,
    speed: 1000,
    fade: true,
    loop: true,
    dots: false,
    arrows: true,
    prevArrow: '<span class="slider-icon slider-icon-prev"><i class="icofont-simple-left"></i></span>',
    nextArrow: '<span class="slider-icon slider-icon-next"><i class="icofont-simple-right"></i></span>',
    
  });
};




     // SlideShow 8 active js
$.fn.SlideShow_8 = function() {
  var $SlideShow_8VAR = this;
  $SlideShow_8VAR.slick({
    adaptiveHeight: true,
    speed: 1000,
    fade: true,
    loop: true,
    dots: true,
    arrows: false,
    prevArrow: '<span class="slider-icon slider-icon-prev"><i class="icofont-simple-left"></i></span>',
    nextArrow: '<span class="slider-icon slider-icon-next"><i class="icofont-simple-right"></i></span>',
    
  });
};



     // SlideShow 9 active js
$.fn.SlideShow_9 = function() {
  var $SlideShow_9VAR = this;
  $SlideShow_9VAR.slick({
    adaptiveHeight: true,
    speed: 1000,
    fade: true,
    loop: true,
    dots: true,
    arrows: false,
    prevArrow: '<span class="slider-icon slider-icon-prev"><i class="icofont-simple-left"></i></span>',
    nextArrow: '<span class="slider-icon slider-icon-next"><i class="icofont-simple-right"></i></span>',
    
  });
};



     // SlideShow 10 active js
$.fn.SlideShow_10 = function() {
  var $SlideShow_10VAR = this;
  $SlideShow_10VAR.slick({
    adaptiveHeight: true,
    speed: 1000,
    arrows: false,
    infinite: true,
    dots: true,
    fade: true,
    customPaging : function(slider, i) {
            var thumb = $(slider.$slides[i]).data('thumb');
            return '<button class="overlay"><img src="'+thumb+'"></button>';
    },
    responsive: [
      {
         breakpoint: 767,
         settings: {
         dots: true,
         autoplay: false,
         autoplaySpeed: 5000,
        }
     }
   ]
    
  });
};



     // SlideShow 11 active js
$.fn.SlideShow_11 = function() {
  var $SlideShow_11VAR = this;
  $SlideShow_11VAR.slick({
    adaptiveHeight: true,
    speed: 1000,
    fade: true,
    loop: true,
    dots: false,
    arrows: true,
    prevArrow: '<span class="slider-icon slider-icon-prev"><i class="icofont-simple-left"></i></span>',
    nextArrow: '<span class="slider-icon slider-icon-next"><i class="icofont-simple-right"></i></span>',
    
  });
};


     // SlideShow 12 active js
$.fn.SlideShow_12 = function() {
  var $SlideShow_12VAR = this;
  $SlideShow_12VAR.slick({
    adaptiveHeight: true,
    speed: 1000,
    fade: true,
    loop: true,
    dots: false,
    arrows: true,
    prevArrow: '<span class="slider-icon slider-icon-prev"><i class="icofont-simple-left"></i></span>',
    nextArrow: '<span class="slider-icon slider-icon-next"><i class="icofont-simple-right"></i></span>',
    
  });
};



     // SlideShow 13 active js
$.fn.SlideShow_13 = function() {
  var $SlideShow_13VAR = this;
  $SlideShow_13VAR.slick({
    adaptiveHeight: true,
    speed: 1000,
    fade: true,
    loop: true,
    dots: false,
    arrows: true,
    prevArrow: '<span class="slider-icon slider-icon-prev"><i class="icofont-simple-left"></i></span>',
    nextArrow: '<span class="slider-icon slider-icon-next"><i class="icofont-simple-right"></i></span>',
    
  });
};


     // SlideShow 14 active js
$.fn.SlideShow_14 = function() {
  var $SlideShow_14VAR = this;
  $SlideShow_14VAR.slick({
    adaptiveHeight: true,
    speed: 1000,
    fade: true,
    loop: true,
    dots: false,
    arrows: true,
    prevArrow: '<span class="slider-icon slider-icon-prev"><i class="icofont-simple-left"></i></span>',
    nextArrow: '<span class="slider-icon slider-icon-next"><i class="icofont-simple-right"></i></span>',
    
  });
};


     // SlideShow 15 active js
$.fn.SlideShow_15 = function() {
  var $SlideShow_15VAR = this;
  $SlideShow_15VAR.slick({
    adaptiveHeight: true,
    speed: 1000,
    fade: true,
    loop: true,
    dots: false,
    arrows: true,
    prevArrow: '<span class="slider-icon slider-icon-prev"><i class="icofont-simple-left"></i></span>',
    nextArrow: '<span class="slider-icon slider-icon-next"><i class="icofont-simple-right"></i></span>',
    
  });
};



     // SlideShow 16 active js
$.fn.SlideShow_16 = function() {
  var $SlideShow_16VAR = this;
  $SlideShow_16VAR.slick({
    adaptiveHeight: true,
    speed: 1000,
    fade: true,
    loop: true,
    dots: false,
    arrows: true,
    prevArrow: '<span class="slider-icon slider-icon-prev"><i class="icofont-simple-left"></i></span>',
    nextArrow: '<span class="slider-icon slider-icon-next"><i class="icofont-simple-right"></i></span>',
    
  });
};



     // SlideShow 17 active js
$.fn.SlideShow_17 = function() {
  var $SlideShow_17VAR = this;
  $SlideShow_17VAR.slick({
    adaptiveHeight: true,
    speed: 1000,
    fade: true,
    loop: true,
    dots: false,
    arrows: true,
    prevArrow: '<span class="slider-icon slider-icon-prev"><i class="icofont-simple-left"></i></span>',
    nextArrow: '<span class="slider-icon slider-icon-next"><i class="icofont-simple-right"></i></span>',
    
  });
};




     // SlideShow 18 active js
$.fn.SlideShow_18 = function() {
  var $SlideShow_18VAR = this;
  $SlideShow_18VAR.slick({
    adaptiveHeight: true,
    speed: 1000,
    fade: true,
    loop: true,
    dots: false,
    arrows: true,
    prevArrow: '<span class="slider-icon slider-icon-prev"><i class="icofont-simple-left"></i></span>',
    nextArrow: '<span class="slider-icon slider-icon-next"><i class="icofont-simple-right"></i></span>',
    
  });
};










      


(function($) {
  "use strict";

  jQuery(document).ready(function(){
    
    // All jQuery activation code paste here
    
    "use strict";

    
    /*---------------------
        Countdown 1
      --------------------- */
    $('.timer-1 [data-countdown]').each(function() {
        var $this = $(this),
            finalDate = $(this).data('countdown');
        $this.countdown(finalDate, function(event) {
            $this.html(event.strftime('<span class="cdown day"> <span>%-D </span><p>Days</p></span> <span class="cdown hour"> <span> %-H</span> <p>Hours</p></span> <span class="cdown minutes"><span>%M</span> <p>Minutes</p> </span>'));
        });
    });
    
    $('.timer-2 [data-countdown]').each(function() {
        var $this = $(this),
            finalDate = $(this).data('countdown');
        $this.countdown(finalDate, function(event) {
            $this.html(event.strftime('<span class="cdown day"> <span>%-D </span><p>Day</p></span> <span class="cdown hour"> <span> %-H</span> <p>Hour</p></span> <span class="cdown minutes"><span>%M</span> <p>Minute</p> </span> <span class="cdown second"><span>%S</span> <p>Second</p> </span>'));
        });
    });
    
    $('.timer-3 [data-countdown]').each(function() {
        var $this = $(this),
            finalDate = $(this).data('countdown');
        $this.countdown(finalDate, function(event) {
            $this.html(event.strftime('<span class="cdown hour"> <span> %-H</span> <p>Hour</p></span> <span class="cdown minutes"><span>%M</span> <p>Minute</p> </span> <span class="cdown second"><span>%S</span> <p>Second</p> </span>'));
        });
    });
    
    
        /*---------------------
        svg img color
    --------------------- */
    // Elements to inject
      var mySVGsToInject = document.querySelectorAll('img.inject-me');
      // Do the injection
      SVGInjector(mySVGsToInject);
    

    /*------ Wow Active ----*/
    new WOW().init();
    
    
    /*------------
        ScrollUp
    ------------------ */
    $.scrollUp({
        scrollText: '<i class="icofont-arrow-up"></i>',
        easingType: 'linear',
        scrollSpeed: 900,
        animation: 'fade'
    });
    
    
    /*--------------------------------
        Cart active
    -----------------------------------*/
    if ($('.pro-details-action').length) {
        var $body = $('body'),
            $cartWrap = $('.pro-details-action'),
            $cartContent = $cartWrap.find('.product-dec-social');
        $cartWrap.on('click', '.social', function(e) {
            e.preventDefault();
            var $this = $(this);
            if (!$this.parent().hasClass('show')) {
                $this.siblings('.product-dec-social').addClass('show').parent().addClass('show');
            } else {
                $this.siblings('.product-dec-social').removeClass('show').parent().removeClass('show');
            }
        });
        /*Close When Click Outside*/
        $body.on('click', function(e) {
            var $target = e.target;
            if (!$($target).is('.pro-details-action') && !$($target).parents().is('.pro-details-action') && $cartWrap.hasClass('show')) {
                $cartWrap.removeClass('show');
                $cartContent.removeClass('show');
            }
        });
    }
    
    /*====== SidebarCart ======*/
    function miniCart() {
        var navbarTrigger = $('.cart-active'),
            endTrigger = $('.cart-close'),
            container = $('.sidebar-cart-active'),
            wrapper2 = $('.main-wrapper');
        
        wrapper2.prepend('<div class="body-overlay"></div>');
        
        navbarTrigger.on('click', function(e) {
            e.preventDefault();
            container.addClass('inside');
            wrapper2.addClass('overlay-active');
        });
        
        endTrigger.on('click', function() {
            container.removeClass('inside');
            wrapper2.removeClass('overlay-active');
        });
        
        $('.body-overlay').on('click', function() {
            container.removeClass('inside');
            wrapper2.removeClass('overlay-active');
        });
    };
    miniCart();
    
    /*-------------------------------
	   Header Search Toggle
    -----------------------------------*/
    var searchToggle = $('.search-toggle');
    searchToggle.on('click', function(e){
        e.preventDefault();
        if($(this).hasClass('open')){
           $(this).removeClass('open');
           $(this).siblings('.search-wrap-3').removeClass('open');
        }else{
           $(this).addClass('open');
           $(this).siblings('.search-wrap-3').addClass('open');
        }
    })
    
    
     /*====== Sidebar Active ======*/
    function sidebarActive() {
        var navbarTrigger = $('.sidebar-active'),
            endTrigger = $('.sidebar-close'),
            container = $('.clickalbe-sidebar-wrapper-active'),
            wrapper3 = $('.main-wrapper-2');
        
        wrapper3.prepend('<div class="body-overlay-2"></div>');
        
        navbarTrigger.on('click', function(e) {
            e.preventDefault();
            container.addClass('sidebar-visible');
            wrapper3.addClass('overlay-active-2');
        });
        
        endTrigger.on('click', function() {
            container.removeClass('sidebar-visible');
            wrapper3.removeClass('overlay-active-2');
        });
        
        $('.body-overlay-2').on('click', function() {
            container.removeClass('sidebar-visible');
            wrapper3.removeClass('overlay-active-2');
        });
    };
    sidebarActive();
    
    /*====== clickable Main Menu active ======*/
    var $clickableMainMenu = $('.clickable-mainmenu-wrap'),
        $clickableSubMenu = $clickableMainMenu.find('.sub-menu-2');
    /*Add Toggle Button in Off Canvas Sub Menu*/
    $clickableSubMenu.siblings('a').append('<span class="menu-expand"><i class="icofont-plus"></i></span>');
    /*Close Off Canvas Sub Menu*/
    $clickableSubMenu.slideUp();
    /*Category Sub Menu Toggle*/
    $clickableMainMenu.on('click', 'li a, li .menu-expand', function(e) {
        var $this = $(this);
        if ($this.parent('li').hasClass('has-sub-menu') || ($this.attr('href') === '#' || $this.hasClass('menu-expand'))) {
            e.preventDefault();
            if ($this.siblings('ul:visible').length) {
                $this.parent('li').removeClass('active').children('ul').slideUp().siblings('a').find('.menu-expand i').removeClass('icofont-minus').addClass('icofont-plus');
                $this.parent('li').siblings('li').removeClass('active').find('ul:visible').slideUp().siblings('a').find('.menu-expand i').removeClass('icofont-minus').addClass(' icofont-plus ');
            } else {
                $this.parent('li').addClass('active').children('ul').slideDown().siblings('a').find('.menu-expand i').removeClass(' icofont-plus ').addClass('icofont-minus');
                $this.parent('li').siblings('li').removeClass('active').find('ul:visible').slideUp().siblings('a').find('.menu-expand i').removeClass('icofont-minus').addClass(' icofont-plus ');
            }
        }
    });
    
    
     /*====== Sidebar menu Active ======*/
    function mobileMenuActive() {
        var navbarTrigger = $('.mobile-menu-button-active'),
            endTrigger = $('.sidebar-close'),
            container = $('.mobile-menu-active'),
            wrapper4 = $('.main-wrapper-3');
        
        wrapper4.prepend('<div class="body-overlay-3"></div>');
        
        navbarTrigger.on('click', function(e) {
            e.preventDefault();
            container.addClass('sidebar-visible');
            wrapper4.addClass('overlay-active-3');
        });
        
        endTrigger.on('click', function() {
            container.removeClass('sidebar-visible');
            wrapper4.removeClass('overlay-active-3');
        });
        
        $('.body-overlay-3').on('click', function() {
            container.removeClass('sidebar-visible');
            wrapper4.removeClass('overlay-active-3');
        });
    };
    mobileMenuActive();
    
    /*--- Language currency active ----*/
    $('.mobile-language-active').on('click', function(e) {
        e.preventDefault();
        $('.lang-dropdown-active').slideToggle(900);
    });
    
    
    // Isotope active
    $('.grid').imagesLoaded(function() {
        // init Isotope
        var $grid = $('.grid').isotope({
            itemSelector: '.grid-item',
            percentPosition: true,
            layoutMode: 'masonry',
            masonry: {
                // use outer width of grid-sizer for columnWidth
                columnWidth: '.grid-item',
            }
        });
    });
    
    /*--------------------------
        Isotope active
    ---------------------------- */
    
    $('.grid-2').imagesLoaded(function() {
        // init Isotope
        $('.grid-2').isotope({
            itemSelector: '.grid-item-2',
            percentPosition: true,
            layoutMode: 'masonry',
            masonry: {
                // use outer width of grid-sizer for columnWidth
                columnWidth: '.grid-sizer',
            }
        });
    });
    
    /*--------------------------
        Isotope active
    ---------------------------- */
    
    $('.grid-3').imagesLoaded(function() {
        // init Isotope
        $('.grid-3').isotope({
            itemSelector: '.grid-item-3',
            percentPosition: true,
            layoutMode: 'masonry',
            masonry: {
                // use outer width of grid-sizer for columnWidth
                columnWidth: 1,
            }
        });
    });
    
        /*--------------------------------
        Product img slider active
    -----------------------------------*/
    $('.product-img-slider-active').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
   
        dots: true,
        fade: false,
        arrows: false,
    });
    
     /*====== SidebarSearch ======*/
    function sidebarSearch() {
        var searchTrigger = $('.search-active'),
            endTriggersearch = $('.megashop-search-close'),
            container = $('.main-search-active');
        
        searchTrigger.on('click', function(e) {
            e.preventDefault();
            container.addClass('search-visible');
        });
        
        endTriggersearch.on('click', function() {
            container.removeClass('search-visible');
        });
        
    };
    sidebarSearch();
    
    /*---------------------
        Video popup
    --------------------- */
    $('.video-popup').magnificPopup({
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        zoom: {
            enabled: true,
        }
    });
    
    
    /*-----------------------
        Shop filter active 
    ------------------------- */
    $('.shop-filter-active').on('click', function(e) {
        e.preventDefault();
        $('.product-filter-wrapper').slideToggle();
    })
    var shopFiltericon = $('.shop-filter-active');
    shopFiltericon.on('click', function() {
        $('.shop-filter-active').toggleClass('active');
    })
   
    
    // Product grid color variant activation code. 
    
    $('.product-color li label').click(function(){
      var variantImage = jQuery(this).parent().find('.hidden a').attr('href');
      jQuery(this).parents('.product-wrapper').find('.popup_cart_image').attr({ src: variantImage }); 
      return false;
    });
    

  });
  
})(jQuery);
